import React from 'react'
import createClass from 'create-react-class'
import PropTypes from 'prop-types'
import moment from 'moment'
import {UncontrolledTooltip} from 'reactstrap'

const CertificateDates = createClass({
  propTypes: {
    id: PropTypes.string.isRequired,
    expiration_date: PropTypes.string,
    confirmation_date: PropTypes.string
  },
  setColor(date) {
    if (date < moment()) {
      return 'red'
    } else if (date < moment().add(1, 'M')) {
      return 'orange'
    }
  },
  renderDate(date) {
    let color = this.setColor(date)
    let daysLeft = date.diff(moment(), 'days')
    return <b style={{color: color}}>{date._i} ({daysLeft})</b>
  },
  render() {
    let id = `CertificateDates_${this.props.id}`
    return (
      <div id={id}>
        {(this.props.expiration_date && this.renderDate(moment(this.props.expiration_date))) || <b>-/</b>}
        <hr style={{marginTop: '0px', marginBottom: '0px'}}/>
        {(this.props.confirmation_date && this.renderDate(moment(this.props.confirmation_date))) || <b>-/</b>}
        {(this.props.expiration_date || this.props.confirmation_date) &&
        <UncontrolledTooltip placement="right" target={id}>
          <i style={{color: 'red'}}>expired</i>
          <br/>
          <i style={{color: 'orange'}}>less than month</i>
          <br/>
          <i>() - days left</i>
        </UncontrolledTooltip>
        }
      </div>
    )
  }
})

export default CertificateDates



// WEBPACK FOOTER //
// ./src/components/Welders/helpers/CertificateDates.js